import React from 'react'
import './styles/Mark.scss'

const Mark = () => (<div className="mark" />)

export default Mark;
